"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var CloseIcon = function (_a) {
    var _b = _a.theme, theme = _b === void 0 ? 'light' : _b, fill = _a.fill, height = _a.height, width = _a.width, rest = __rest(_a, ["theme", "fill", "height", "width"]);
    var fillColor = theme === 'light' ? 'black' : 'white';
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ fill: fill !== null && fill !== void 0 ? fill : fillColor, xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: width !== null && width !== void 0 ? width : '16px', height: height !== null && height !== void 0 ? height : '16px' }, rest, { children: (0, jsx_runtime_1.jsx)("path", { d: 'M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z' }) })));
};
exports.CloseIcon = CloseIcon;
